import React from 'react'
import { useTranslation } from 'react-i18next'

import { useChecklistTypesStepDef } from './checklistTypesStep/ChecklistTypesStep'
import { useGroupStepDef } from './groupStep/GroupStep'
import { useGeneralStepDef } from './generalStep/GeneralStep'
import { usePlaceLevelStepDef } from './placeLevelStep/PlaceLevelStep'
import { useAssetStepDef } from './assetStep/AssetStep'
import { useResumeStepDef } from './resumeStep/ResumeStep'
import { useIsEditing } from './_form/SegmentationFormHandler'
import { useSaveSegmentationRequest } from './_requests/saveSegmentation'
import Steps from '../../../components/steps/Steps'

const EditSegmentationForm = () => {
  const { t } = useTranslation('editSegmentation')
  const isEditing = useIsEditing()
  const generalStep = useGeneralStepDef()
  const placeLevelStep = usePlaceLevelStepDef()
  const assetStep = useAssetStepDef()
  const checklistTypeStep = useChecklistTypesStepDef()
  const groupStep = useGroupStepDef()
  const resumeStep = useResumeStepDef()

  const steps = [generalStep, checklistTypeStep, groupStep, placeLevelStep, assetStep, resumeStep]
  const [onSubmit, { loading, error }] = useSaveSegmentationRequest()

  return <Steps t={t} isEditing={isEditing} steps={steps} onSubmit={onSubmit} loading={loading} errorMessage={error} />
}

export default EditSegmentationForm
